<script lang="ts">
  import { inertia } from "@inertiajs/svelte"
  import { _, locale } from "svelte-i18n"

  import LanguageSwitcher from "@/components/language-switcher.svelte"
  import MarketingSignedIn, {
    PILL_CLASS,
  } from "@/components/marketing-signed-in.svelte"
  import SignInLink from "@/components/sign-in-link.svelte"
  import TobyIcon from "@/components/toby-icon.svelte"
  import { homePath } from "@/lib/locale-routes"

  type Props = {
    signed_in?: boolean
  }
  const { signed_in = false }: Props = $props()

  const homeHref = $derived(homePath($locale ?? "en"))
</script>

<!-- The divider spans the full viewport (full-bleed border, like the section
     dividers below), but the content sits in the shared centered max-w-6xl
     column so the logo lines up with the hero, the sections, and the footer. -->
<header class="border-b border-black/[.06] dark:border-white/10">
  <div
    class="mx-auto flex max-w-6xl items-center justify-between px-6 py-3.5 lg:py-[18px]"
  >
    <a href={homeHref} use:inertia class="flex items-center gap-2.5">
      <TobyIcon size={36} />
      <span class="hidden text-[13.5px] font-semibold md:inline">
        {$_("brandSlogan")}
      </span>
    </a>
    <nav class="flex items-center gap-3.5 max-[390px]:gap-2 md:gap-[18px]">
      <!-- Widths measured across all 19 languages: the name fits signed out
           from 375px; signed in, the longer pill and the avatar need `sm`. -->
      <LanguageSwitcher
        plain
        labelClass={signed_in
          ? "hidden sm:inline"
          : "hidden min-[375px]:inline"}
      />
      {#if signed_in}
        <MarketingSignedIn />
      {:else}
        <SignInLink
          class="text-[13px] text-neutral-600 hover:text-neutral-900 dark:text-neutral-300 dark:hover:text-white"
        >
          {$_("home.sign_in")}
        </SignInLink>
        <SignInLink class={PILL_CLASS}>
          {$_("home.hero_cta")}
        </SignInLink>
      {/if}
    </nav>
  </div>
</header>
